import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43dadaef"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "burn-summary overflow-visible" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "height-enforcer" }, null, -1))
const _hoisted_3 = { class: "tooltip" }
const _hoisted_4 = { class: "slideshow" }
const _hoisted_5 = {
  key: 0,
  class: "absolute mx-auto stack-image"
}
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-full\" viewBox=\"0 0 79 146\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-43dadaef><path d=\"M67.825 45.6194L79 39.1675L11.9502 0.456268L0.775208 6.90814L67.825 45.6194Z\" fill=\"white\" fill-opacity=\"0.3\" data-v-43dadaef></path><path d=\"M67.825 145.544L79 139.092L11.9502 100.381L0.775208 106.833L67.825 145.544Z\" fill=\"white\" fill-opacity=\"0.3\" data-v-43dadaef></path><path d=\"M67.564 123.161L78.739 116.71V39.287L67.564 45.7389L67.564 123.161Z\" fill=\"white\" fill-opacity=\"0.25\" data-v-43dadaef></path><path d=\"M67.6966 45.5795L67.6966 123.002L0.64679 84.2908L0.646795 6.86831L67.6966 45.5795Z\" fill=\"white\" fill-opacity=\"0.2\" data-v-43dadaef></path></svg>", 1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "preview-burn-asset fire" }
const _hoisted_9 = { class: "subtitle flex flex-row px-1 justify-between cursor-pointer hover:opacity-75" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 2,
  class: "ml-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltiptext" }, " You will need to burn certain tokens. Click here to see Burn Rules. ", -1))
const _hoisted_14 = { class: "right h-full w-1/2 overflow-visible flex flex-col justify-center items-center content-center" }
const _hoisted_15 = { class: "tooltip" }
const _hoisted_16 = { class: "tooltiptext" }
const _hoisted_17 = {
  key: 0,
  class: "flex flex-row gap-2 w-full summary-column gap-6"
}
const _hoisted_18 = { class: "flex flex-col gap-2 summary-column-item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "PRICE", -1))
const _hoisted_20 = { class: "flex flex-col gap-2 w-full summary-column-item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "TOTAL REDEEMED", -1))

import {
  isUnlimitedSupply, abbreviateAddress, NFTMetadata,
  convertPotentialWeb3ProtocolToWeb2,
} from '@/lib/util';
import {
  computed, onMounted, ref,
} from 'vue';
import MediaLoader from '@/components/MediaLoader.vue';
import BurnRulesModal from '@/components/BurnRulesModal.vue';
import Creator1155Contract from '@/classes/creator1155Contract';
import Creator721Contract from '@/classes/creator721Contract';
import Fire from '@/components/Fire.vue';
import { formatEther } from '@ethersproject/units';
import { useBR } from '@/composables/useBR';
import { BigNumber } from '@ethersproject/bignumber';


interface BurnRedeemProps {
  redeemAssetMetadata: NFTMetadata;
  redeemTokenName?: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BurnSummary',
  props: {
    redeemAssetMetadata: null,
    redeemTokenName: null
  },
  setup(__props: any) {

const props = __props as {
  redeemAssetMetadata: NFTMetadata;
  redeemTokenName?: string;
};



const burnAssetMedia = ref<string[]>([]);
const showRulesModal = ref(false);
const visibleBurnAssetIndex = ref(0);
const showAllSlidesRightNow = ref(true);
const { burn, studioInstance, redeemSpec, redeemContractAddress } = useBR();

const numberToBurnPerRedeem = computed((): number => {
  if (burn.value?.burnSet[0].items[0].amount.toNumber()) {
    return burn.value?.burnSet[0].items[0].amount.toNumber() || 1;
  }

  return 0;
});

/**
 * If there are multiple burn assets, we want to show a slideshow of the burn assets.
 * We do this by setting the first slide to be visible and the rest to be invisible.
 * Then we set an interval to change the visible slide every 3 seconds.
 * CSS handles all of the actual animations when .fadein and .fadeout are added/removed.
 */
const startSlideshowAnimationIfNeeded = () => {
  if (burnAssetMedia.value.length > 1) {
    // @dev: ensures that just the first slide is visible off the bat and the rest are faded out
    window.setTimeout(() => {
      const slides = document.querySelectorAll('.slide');
      slides.forEach((slide, idx) => {
        if (idx !== 0) {
          slide.classList.remove('fadein');
          slide.classList.add('fadeout');
          // @dev: this ensures the first slide is visible on initial load
          // @dev: remove it now so that fading out functions properly
          showAllSlidesRightNow.value = false;
        }
      });
    }, 100);

    // @dev: every three seconds change the visible slide by fading out old slide fading in new slide
    window.setInterval(() => {
      visibleBurnAssetIndex.value += 1;
      let lastVisibleBurnAssetIndex = visibleBurnAssetIndex.value - 1;

      if (visibleBurnAssetIndex.value === burnAssetMedia.value.length) {
        visibleBurnAssetIndex.value = 0;
      }

      if (lastVisibleBurnAssetIndex === -1) {
        lastVisibleBurnAssetIndex = burnAssetMedia.value.length - 1;
      }

      const slides = document.querySelectorAll('.slide');
      slides.forEach((slide, idx) => {
        if (idx === visibleBurnAssetIndex.value) {
          slide.classList.add('fadein');
          slide.classList.remove('fadeout');
          slide.classList.remove('opacity-100');
        } else {
          slide.classList.remove('fadein');
          slide.classList.add('fadeout');
          slide.classList.remove('opacity-100');
        }
      });
    }, 3000);
  }
};

const findAllBurnAssets = async () => {
  if (burn.value?.burnSet) {
    for (let i = 0; i < burn.value.burnSet.length; i++) {
      const group = burn.value.burnSet[i];
      const item = group.items[0];

      if (item.validationType === 1 && item.contractAddress) {
        for (let j = 1; j <= 3; j++) {
          try {
            let tokenURI = '';
            if (item.tokenSpec === 1) {
              // single erc721 burn
              const c = new Creator721Contract(item.contractAddress);
              tokenURI = await c.tokenURI(j.toString());
            }

            if (item.tokenSpec === 2) {
              // single erc1155 burn
              const c = new Creator1155Contract(item.contractAddress);
              tokenURI = await c.uri(j.toString());
            }

            tokenURI = convertPotentialWeb3ProtocolToWeb2(tokenURI, BigNumber.from(j));
            const metadataResponse = await fetch(tokenURI);
            const jsonMetadata = await metadataResponse.json();

            burnAssetMedia.value.push(jsonMetadata.image);
          } catch {
            // do nothing
          }
        }
      }

      if (item.validationType === 2) {
        if (item.minTokenId && item.maxTokenId && item.minTokenId?.toString() === item.maxTokenId?.toString()) {
          try {
            let tokenURI = '';
            if (item.tokenSpec === 1) {
              // single erc721 burn
              const c = new Creator721Contract(item.contractAddress);
              tokenURI = await c.tokenURI(item.minTokenId.toString());
            }

            if (item.tokenSpec === 2) {
              // single erc1155 burn
              const c = new Creator1155Contract(item.contractAddress);
              tokenURI = await c.uri(item.minTokenId.toString());
            }

            tokenURI = convertPotentialWeb3ProtocolToWeb2(tokenURI, item.minTokenId);
            const metadataResponse = await fetch(tokenURI);
            const jsonMetadata = await metadataResponse.json();

            burnAssetMedia.value.push(jsonMetadata.image);
          } catch {
            // do nothing
          }
        } else {
          try {
            let min = item.minTokenId;
            let max = item.maxTokenId;

            let tokenURI1 = '';
            let tokenURI2 = '';
            if (item.tokenSpec === 1) {
              // single erc721 burn
              const c = new Creator721Contract(item.contractAddress);
              tokenURI1 = await c.tokenURI(min?.toString() || '');
              tokenURI2 = await c.tokenURI(max?.toString() || '');
            }


            if (item.tokenSpec === 2) {
              // single erc1155 burn
              const c = new Creator1155Contract(item.contractAddress);
              tokenURI1 = await c.uri(min?.toString() || '');
              tokenURI2 = await c.uri(max?.toString() || '');
            }

            tokenURI1 = convertPotentialWeb3ProtocolToWeb2(tokenURI1, min);
            tokenURI2 = convertPotentialWeb3ProtocolToWeb2(tokenURI2, max);
            const metadataResponse = await fetch(tokenURI1);
            const jsonMetadata = await metadataResponse.json();
            burnAssetMedia.value.push(jsonMetadata.image);

            const metadataResponse2 = await fetch(tokenURI2);
            const jsonMetadata2 = await metadataResponse2.json();
            burnAssetMedia.value.push(jsonMetadata2.image);
          } catch {
            // do nothing
          }
        }
      }

      if (item.validationType === 3) {
        // if it's a merkle tree try to pull the first 5 token URIs
        // extract 5 images from the 5 URI
        const tokenIds = studioInstance?.value?.publicData?.burnSet?.[i]?.items?.[0]?.tokenIds;
        const firstFiveTokenIds = tokenIds?.slice(0, 2) || [];

        for (let j = 0; j < 2; j++) {
          let tokenId = firstFiveTokenIds[j];
          if (!tokenId) continue;

          try {
            let tokenURI = '';
            if (item.tokenSpec === 1) {
              // single erc721 burn
              const c = new Creator721Contract(item.contractAddress);
              tokenURI = await c.tokenURI(tokenId);
            }

            if (item.tokenSpec === 2) {
              // single erc1155 burn
              const c = new Creator1155Contract(item.contractAddress);
              tokenURI = await c.uri(tokenId);
            }

            tokenURI = convertPotentialWeb3ProtocolToWeb2(tokenURI);
            const metadataResponse = await fetch(tokenURI);
            const jsonMetadata = await metadataResponse.json();

            burnAssetMedia.value.push(jsonMetadata.image);
          } catch {
            // do nothing
          }
        }
      }
    }
  }
};

onMounted(async () => {
  await findAllBurnAssets();
  startSlideshowAnimationIfNeeded();
});

const isSingle1155Burn = computed(() => {
  if (burn.value?.burnSet[0].items[0].validationType === 2) {
    if (burn.value.burnSet[0].items[0].tokenSpec === 2) {
      if (burn.value.burnSet.length === 1 && burn.value.burnSet[0].items.length === 1) {
        return true;
      }
    }
  }

  return 0;
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: "left relative h-full w-1/2 overflow-visible flex flex-col justify-center items-center content-center z-5",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showRulesModal.value = true))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(burnAssetMedia.value, (media, idx) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "slide opacity-100",
                key: media,
                style: _normalizeStyle({
                zIndex: burnAssetMedia.value.length - idx
              })
              }, [
                _createVNode(MediaLoader, {
                  class: "preview-burn-asset relative cursor-pointer",
                  "code-comment": "Never pass a Video or GLB here as media!",
                  media: media
                }, null, 8, ["media"])
              ], 4))
            }), 128)),
            (!burnAssetMedia.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(Fire)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_unref(isSingle1155Burn))
                ? (_openBlock(), _createElementBlock("dt", _hoisted_10, " Burn Qty. "))
                : _createCommentVNode("", true),
              (!_unref(isSingle1155Burn))
                ? (_openBlock(), _createElementBlock("dt", _hoisted_11, " Burn Rules "))
                : _createCommentVNode("", true),
              (_unref(isSingle1155Burn))
                ? (_openBlock(), _createElementBlock("dd", _hoisted_12, _toDisplayString(_unref(numberToBurnPerRedeem)), 1))
                : _createCommentVNode("", true)
            ]),
            _hoisted_13
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          (props.redeemAssetMetadata)
            ? (_openBlock(), _createBlock(MediaLoader, {
                key: 0,
                class: "preview-redeem-asset relative cursor-pointer",
                "code-comment": "Never pass a Video or GLB here as media!",
                media: 
              _unref(studioInstance)?.publicData?.image ||
                props.redeemAssetMetadata.image ||
                props.redeemAssetMetadata.animation_url
            
              }, {
                injector: _withCtx(() => [
                  _createElementVNode("span", _hoisted_16, " You will redeem " + _toDisplayString(props.redeemTokenName) + " on smart contract " + _toDisplayString(_unref(abbreviateAddress)(_unref(redeemContractAddress))) + " as an " + _toDisplayString(_unref(redeemSpec)?.toUpperCase()) + " token. ", 1)
                ]),
                _: 1
              }, 8, ["media"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    (_unref(burn))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("dd", null, _toDisplayString(_unref(burn) && _unref(burn).cost && _unref(burn).cost.gt(0) ? _unref(formatEther)(_unref(burn).cost) + ' ETH' : 'FREE'), 1)
          ]),
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createElementVNode("dd", null, _toDisplayString(_unref(burn) ? _unref(burn).redeemedCount.toString() : '?') + " " + _toDisplayString(_unref(isUnlimitedSupply)(_unref(burn)) ? '' : `/ ${_unref(burn)?.totalSupply.toString()}`), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (showRulesModal.value)
      ? (_openBlock(), _createBlock(BurnRulesModal, {
          key: 1,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (showRulesModal.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})